import * as main from '../utils/index';
import * as auth from '../utils/auth';
import * as route from '../utils/route';
import downloadUrl from '../utils/download';
import { getYourIP } from '../utils/getIp';
import * as validate from '../utils/validate';

export default {
  ...main,
  auth,
  route,
  downloadFiles: downloadUrl,
  getIp: getYourIP,
  validate,
};
